export default __webpack_public_path__ + "static/media/DSC42006.abb914a4.jpg";